import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AppliancesTitleStyles";

export default class AppliancesTitle extends Component {
  render() {
    return (
      <div className={css(styles.titleWrapper)}>
        <h2 className={css(styles.appliancesTitle)}>Appliances</h2>
        <p className={css(styles.pastHour)}>
          <span className={css(styles.onHightlight)}>On</span> in this{" "}
          {this.props.time_unit}
        </p>
      </div>
    );
  }
}
